import React, { useEffect, useState } from 'react';
import { Table, Input, Select, Button, message, Form, Modal, InputNumber, Popover } from 'antd';
import { Saveapi, equipWOCategory, equipWOPositonCategory, equipWOSubCategory, equipWOTaskCategory, getWorkOrderTable, partSubmitApi, fetchNotTerminatedEmployeesWRTDept } from '../../Services/LocomotiveServices';
import { useHistory } from 'react-router-dom';
import { AssignTo, ContractorTo, get_employee_AssignTo_listing_not_Terminated, } from '../../Services/employee';
import { DeleteOutlined } from '@material-ui/icons';
import PartModal from './Modal/PartModal';
import { EditOutlined, NotificationFilled } from '@ant-design/icons';
import roleManager from '../../Components/roles';
import { Colors } from '../../helpers/Colors';
import { maxWidth } from '@mui/system';
import { getRoleID, haveAccessByRole } from '../../helpers';
const { Option } = Select;

const LocomotiveTable = ({ status, reload, reloadState, setReload, workOrder, workOrderData, setWorkOrderData, mode }) => {

    const history = useHistory()
    const { location } = history
    const id = location?.state?.id
    const [categories, setCategories] = useState([]);
    const [employees, setEmployees] = useState([]);
    const [contractors, setContractors] = useState([]); // Add this line to define contractors
    const statusOptions = [
        { label: "Assigned", value: 'Assigned' },
        { label: "Completed", value: 'Completed' },
    ]
    const [partModalVisible, setPartModalVisible] = useState(false);
    const [form] = Form.useForm()
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [rowSelected, setRowSelected] = useState()
    const [notTerminatedEmployees, setNotTerminatedEmployees] = useState([])
    const [isErrorModalVisiblePart, setIsErrorModalVisiblePart] = useState(false);
    const [isErrorModalVisibleNotes, setIsErrorModalVisibleNotes] = useState(false);
    const [isGallonsModalVisible, setIsGallonsModalVisible] = useState(false);
    const [gallonsValue, setGallonsValue] = useState(0);
    const [disabledCheck, setDisabledCheck] = useState(false);
    const [isApiCheck, setisApiCheck] = useState(false)
    const [completedUser, setCompletedUser] = useState();
    const user = JSON.parse(localStorage.getItem('user_profile'));
    const isRoleHidden = haveAccessByRole(11);
    const handleOpenModal = (index) => {
        form.setFieldValue("PartType", workOrderData[index]['PartType'])
        form.setFieldValue("PartNbr", workOrderData[index]['PartNbr'])
        form.setFieldValue("PartSerialNbr", workOrderData[index]['PartSerialNbr'])

        setPartModalVisible(true);
        setSelectedRowIndex(index);
    };


    const fetchNotTerminatedEmployees = async () => {
        let response = await fetchNotTerminatedEmployeesWRTDept()
        if (response?.httpStatus === 200) {
            let data = response?.data?.rows?.map((item, index) => ({
                ...item,
                fullName: `${item?.firstName} ${item?.lastName}`,
            }))
            setNotTerminatedEmployees(data)
        }
    }

    useEffect(() => {
        if (isApiCheck) fetchNotTerminatedEmployees()
    }, [isApiCheck])


    const handleSubmit = () => {
        const isEmptyOrSpaces = /^\s*$/.test(gallonsValue);
        if (isEmptyOrSpaces) {
            message.error('Please add gallons value!');
            return;
        }
        const isInvalidInput = isNaN(parseFloat(gallonsValue));
        if (isInvalidInput) {
            message.error('Please add a valid number for gallons!');
            return;
        }

        let newData = [...workOrderData];
        newData[selectedRowIndex].SvrcGallons = gallonsValue;


        const user = JSON.parse(localStorage.getItem('user_profile'));
        newData[selectedRowIndex]['AsgnCmplById'] = user?.id;
        newData[selectedRowIndex]['Status'] = 'Completed';
        setCompletedUser(user)

        setWorkOrderData(newData);


        // submitForm({ SvrcGallons: parseFloat(gallonsValue), Status: "Completed" });
        setIsGallonsModalVisible(false);
        setGallonsValue(0);
    };
    const handlePartsSave = async (values) => {
        let newData = [...workOrderData];
        const { PartType, PartNbr, PartSerialNbr } = values;
        newData[selectedRowIndex].PartType = PartType;
        newData[selectedRowIndex].PartNbr = PartNbr;
        newData[selectedRowIndex].PartSerialNbr = PartSerialNbr;

        await submitForm(values)
        setPartModalVisible(false);
        setWorkOrderData(newData);

    }

    const handleSelectChange = async (index, value, column) => {
        let newData = [...workOrderData];

        if (column === 'Status' && value === 'Completed') {
            const { PartType, PartNbr, Notes } = newData[index];
            setRowSelected(index)
            let currentRow = newData[index]
            let selectedTask = currentRow?.taskOptions?.filter((task) => task?.id == currentRow?.TaskId)
            if (selectedTask?.length) selectedTask = selectedTask[0]
            if (selectedTask?.Notes === true && !Notes) {
                setIsErrorModalVisibleNotes(true)
                return;
            }
            if (selectedTask?.Part === true && (!PartType || !PartNbr)) {
                setIsErrorModalVisiblePart(true)
                return;
            }
            if ((workOrderData[index]?.SvrcGallons === null && workOrderData[index]?.EquipWOTaskDD?.SvrcGallons === true) || (workOrderData[index]?.SvrcGallons === undefined && workOrderData[index]?.EquipWOTaskDD?.SvrcGallons === true)) {
                setSelectedRowIndex(index);
                setIsGallonsModalVisible(true)
                return;
            }
            const user = JSON.parse(localStorage.getItem('user_profile'));
            newData[index]['AsgnCmplById'] = user?.id;
            newData[index][column] = value;
            setCompletedUser(user)
        }

        if (column == 'Category') {
            const categoryId = categories.find((item) => item.Category === value)?.id;
            const { subCategories, tasks } = await fetchSubCategories(categoryId, index)
            if (categoryId === 8) setisApiCheck(true)
            newData[index]['subCategoryOptions'] = subCategories;
            newData[index]['taskOptions'] = []; // Reset task options when changing the category
            newData[index]['SubCategory'] = '';
            newData[index]['TaskId'] = '';
            newData[index]['Position'] = null;
        }
        if (column == 'SubCategory') {
            const subCategoryId = workOrderData[index]?.subCategoryOptions?.find((item) => item.SubCategory === value)?.id;
            const { tasks } = await fetchTasks(subCategoryId)
            newData[index]['taskOptions'] = tasks;
            newData[index]['SubCategory'] = value;
            newData[index]['TaskId'] = null;
            newData[index]['Position'] = null;
        }
        if (column === 'Status' && value === 'Completed') {
            const user = JSON.parse(localStorage.getItem('user_profile'))
            newData[index]['AsgnCmplById'] = user?.id
            newData[index][column] = value;

        }
        if (column === 'TaskId') {
            const positions = await fetchPositions(value);
            newData[index]['TaskId'] = value;
            newData[index]['positionOptions'] = positions;
            newData[index]['Position'] = null;
        }
        else {
            newData[index][column] = value;
        }
        if (column === 'AssignedToId') {
            newData[index][column] = value;
        } else if (column === 'assignedToType') {
            // Update only the selected row's assignedToType
            newData[index].assignedToType = value;
        } else {
            // For other columns, update the entire row
            newData[index][column] = value;
        }

        if (column === 'Position') {
            if (!value?.length)
                newData[index]['Position'] = null;
            else {
                let currentPosition = newData[index].Position || '';
                // Split the string into an array
                let selectedValues = typeof currentPosition == 'string' ? currentPosition.split(', ') : [];
                // Toggle the selection of the clicked value for 'Position'
                if (selectedValues.includes(value)) {
                    selectedValues = selectedValues.filter((val) => val !== value);
                } else {
                    selectedValues.push(value);
                }
                // Update the state with the modified string
                newData[index]['Position'] = selectedValues.join(', ') || '';
            }
        }
        setWorkOrderData(newData);
    };
    const submitForm = async (values, check) => {
        let { Status } = values;
        try {
            let idd;
            if (workOrderData.length) {
                idd = workOrderData[selectedRowIndex]?.id ? workOrderData[selectedRowIndex]?.id : workOrderData[rowSelected]?.id;
            } else {
                console.error('workOrderData is undefined or not iterable');
                return;
            }
            const updatedValues = { ...values, SvrcGallons: values?.SvrcGallons, Status: Status };
            let tempArray = [...workOrderData];
            tempArray[selectedRowIndex || rowSelected] = { ...tempArray[selectedRowIndex || rowSelected], ...updatedValues };
            setWorkOrderData(tempArray);
            setPartModalVisible(false);
            await partSubmitApi(idd, updatedValues);
        } catch (error) {
            console.error('Error submitting form:', error);
            // Handle error
        }
    };
    const handleSave = async () => {
        let hasNull = false
        workOrderData.forEach(item => {
            if (!item?.Category || !item?.SubCategory || !item.TaskId)
                hasNull = true
        });
        if (hasNull)
            return message.error('Category, subCategory and Task is required')
        const tempArray = [...workOrderData]
        const tasks = tempArray?.map((wo, index) => {
            if (wo?.AsgnCmplById === 'N/A' || !wo?.AsgnCmplById || wo?.AsgnCmplById === '')
                delete wo.AsgnCmplById;
            if (!wo?.Status || wo?.Status === '')
                delete wo.Status;
            if (!wo?.AssignedToId || wo?.AssignedToId === '')
                delete wo.AssignedToId;
            if (wo?.Status === 'Completed') {
                const { PartType, PartNbr, Notes } = tempArray[index];
                if (wo?.EquipWOTaskDD?.Notes === true && !Notes) {
                    setIsErrorModalVisibleNotes(true)
                    return 'new error';
                }
                if (wo?.EquipWOTaskDD?.Part === true && (!PartType || !PartNbr)) {
                    setIsErrorModalVisiblePart(true)
                    return 'new error';
                }
            }
            setDisabledCheck(true)
            return wo;
        });
        if (tasks.some(task => task === 'new error')) {
            return;
        }
        try {
            const response = await Saveapi(id, { tasks });

            if ((response?.httpStatus && response?.httpStatus == 200) || (response?.status && response?.status == 200)) {
                setWorkOrderData([]);
                setReload(!reload);
            }
        }
        catch (error) {
            console.error('Custom Error Message:', error);
        }
    };
    const updateWOTask = async (workOrders, woTask) => {

        const { EquipWOTaskDD: { EquipWOSubCategory: { id: SubCategoryId, EquipWOCategory: { id: CategoryId } } }, TaskId } = woTask
        console.log({ EquipWOTaskDD: { EquipWOSubCategory: { id: SubCategoryId, EquipWOCategory: { id: CategoryId } } }, TaskId });
        if (CategoryId === 8) setisApiCheck(true)
        const { subCategories } = await fetchSubCategories(CategoryId)
        const { tasks } = await fetchTasks(SubCategoryId)
        const positions = await fetchPositions(TaskId)
        workOrders.push({
            ...woTask,
            subCategoryOptions: subCategories || [],
            taskOptions: tasks || [],
            positionOptions: positions || [],
            Category: woTask?.EquipWOTaskDD?.EquipWOSubCategory?.EquipWOCategory?.Category || [],
            SubCategory: woTask?.EquipWOTaskDD?.EquipWOSubCategory?.SubCategory || [],
            assignedToType: woTask?.AssignedToId ? 'employee' : woTask?.AssignedToContractorId ? 'contractor' : null
        })
        console.log(workOrders, woTask);
    }
    const contractormap = (data) => {
        let {
            firstName,
            lastName,
            Company
        } = data;

        let output = '';

        if (Company)
            output = Company;

        if (Company && firstName && lastName)
            output = output + "-"

        if (firstName && lastName)
            output = `${output} ${firstName} ${lastName[0]}.`

        return output;
    };
    const fetchWorkOrders = async () => {
        try {
            await fetchEmployees()
            await fetchContractors()
            await fetchCategories()
            const response = await getWorkOrderTable(id);

            if (!response?.data?.length)
                return setWorkOrderData([])
            const workOrders = []
            const promises = []
            response?.data?.forEach(async (woTask) => {

                if (woTask?.EquipWOTaskDD) promises.push(updateWOTask(workOrders, woTask))
            })
            await Promise.all(promises)
            console.log(workOrders);
            workOrders?.sort((a, b) => new Date(a?.createdAt) - new Date(b?.createdAt))
            setWorkOrderData(prev => { return prev = workOrders });
            // getWorkOrderById(id)
        } catch (error) {
            console.error('Error fetching work order table data:', error);
        }
    };
    const fetchEmployees = async () => {
        let result = await get_employee_AssignTo_listing_not_Terminated()
        const data = result?.data?.rows?.map((item, index) => ({
            ...item,
            fullName: `${item?.firstName} ${item?.lastName}`,
        }))
        setEmployees(data)

    }
    const fetchContractors = async () => {
        // Fetch contractors data and set the state
        try {
            const result = await ContractorTo();
            const data = result?.data.map((item, index) => ({
                ...item,
                fullName: contractormap(item),
            }))
            setContractors(data);

        } catch (error) {
            console.error('Error fetching contractors data:', error);
        }
    };
    const fetchPositions = async (taskID) => {
        try {
            const response = await equipWOPositonCategory(taskID);
            if (!response?.data) return []
            const positions = response?.data?.map((pos) => ({ value: pos, label: pos }))
            return positions
        } catch (error) {
            console.error('Error fetching position data:', error);
        }
    };
    const fetchTasks = async (subCategoryID) => {
        try {
            const response = await equipWOTaskCategory(subCategoryID);
            const taskID = response?.data[0]?.id;
            let positions = [];

            if (taskID) {
                positions = await fetchPositions(taskID);
            }

            return { tasks: response?.data || [], positions };
        } catch (error) {
            console.error('Error fetching task data:', error);
        }
    };
    const fetchSubCategories = async (categoryID) => {
        try {
            const response = await equipWOSubCategory(categoryID);
            const subCategoryId = response?.data[0]?.id;
            let tasks = {};

            if (subCategoryId) {
                tasks = await fetchTasks(subCategoryId);
            }

            return { subCategories: response?.data || [], task: tasks.tasks || [] };
        } catch (error) {
            console.error('Error fetching subcategory data:', error);
        }
    };
    const fetchCategories = async () => {

        try {
            const response = await equipWOCategory();
            setCategories(response?.data);
        } catch (error) {
            console.error('Error fetching category data:', error);
        }

    };
    const handleGallonsChange = (value) => {
        setGallonsValue(value);
    };
    const roleMechanic = (index) => {

        const roleIdWOTable = workOrderData[index]?.AssignedTo?.id;
        const user = JSON.parse(localStorage.getItem('user_profile'))
        if (haveAccessByRole(11))
            if (roleIdWOTable != user?.id) return true

        return false;

    }
    const IsNewTask = (index) => {
        return workOrderData[index]?.id ? true : false;
    }

    const roleMechanicTest2 = (index) => {
        const roleIdWOTableId = workOrderData[index]?.RoleCreated;
        if (haveAccessByRole(11))
            if (!getRoleID()?.includes(roleIdWOTableId)) return true
        if (haveAccessByRole(10))
            if ([9, 2].includes(roleIdWOTableId)) return true

        return false;

    }
    const createdByRole = (index) => {
        if ((haveAccessByRole(11)) && (workOrderData[index]?.RoleCreated == 11)) return true
        return false;

    }


    const handleFieldChange = (index, value, field) => {
        let newData = [...workOrderData];
        newData[index][field] = value;
        setWorkOrderData(newData);
    };
    const handleDelete = async (index) => {
        let tempArray = [...workOrderData]
        tempArray = tempArray?.filter((item, i) => i !== index)
        // setWorkOrderData(tempArray)
        setWorkOrderData(tempArray);
    };
    const addRow = () => {
        let tempArray = [...workOrderData]
        tempArray.push(
            {
                Category: "",
                SubCategory: "",
                TaskId: "",
                Position: "",
                PartType: "",
                PartNbr: "",
                PartSerialNbr: "",
                AssignedToId: "",
                Status: "",
                AsgnCmplById: "",
                Notes: "",
                subCategoryOptions: [],
                taskOptions: [],
                positionOptions: []
            }
        )
        setWorkOrderData(tempArray)
    }

    const columns = [
        {
            title: 'Category',
            dataIndex: 'Category',
            // width: 120,
            render: (text, record, index) => (
                <Select
                    style={{ width: '120px' }}
                    value={(record?.Category)}
                    defaultValue={(record.EquipWOTaskDD?.EquipWOSubCategory?.EquipWOCategory?.Category)}
                    onChange={(value) => handleSelectChange(index, value, 'Category')} // Pass 'Category' to identify the specific column
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                        (createdByRole(index) ? false :
                            (IsNewTask(index) && (roleMechanic(index) || roleMechanicTest2(index))) ? true :
                                (status === 'Reviewed-Approved'
                                    || status === 'Closed-WNC'
                                    || status === 'Cmpl Pending Review'
                                    || record.Status === 'Closed'))}
                >
                    {categories.map((item) => (
                        <Option key={item.id} value={item.Category}>
                            {item.Category}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Sub Category',
            dataIndex: 'SubCategory',
            // width: 10,
            render: (text, record, index) => (
                <Select
                    style={{ width: '120px' }}
                    value={(record?.SubCategory)}
                    defaultValue={(record.EquipWOTaskDD?.EquipWOSubCategory?.SubCategory)}
                    onChange={(value) => handleSelectChange(index, value, 'SubCategory')}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                        (createdByRole(index) ? false :

                            (IsNewTask(index) && (roleMechanic(index) || roleMechanicTest2(index))) ? true :
                                (record.Status === 'Closed'
                                    || status === 'Reviewed-Approved'
                                    || status === 'Closed-WNC'
                                    || status === 'Cmpl Pending Review'
                                ))} // Disable if status is Reviewed-Approved


                >
                    {record?.subCategoryOptions?.map((item) => (
                        <Option key={item.id} value={item.SubCategory}>
                            {item.SubCategory}
                        </Option>
                    ))}
                </Select>
            ),
        },

        {
            title: 'Task',
            dataIndex: 'TaskId',
            render: (text, record, index) => (
                <Select
                    style={{ width: '320px' }}
                    value={record?.taskOptions?.length ? record?.TaskId : null}
                    defaultValue={record?.EquipWOTaskDD?.Task}
                    onChange={(value) => {
                        if (record.Status === 'Completed') {
                            handleSelectChange(index, 'Assigned', 'Status');
                        }
                        handleSelectChange(index, value, 'TaskId');
                    }}
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                        option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    disabled={
                        createdByRole(index)
                            ? false
                            : IsNewTask(index) && (roleMechanic(index) || roleMechanicTest2(index))
                                ? true
                                : record?.taskOptions?.length === false ||
                                record.Status === 'Closed' ||
                                status === 'Reviewed-Approved' ||
                                status === 'Closed-WNC' ||
                                status === 'Cmpl Pending Review'
                    }
                >
                    {record?.taskOptions?.map((item) => (
                        <Option key={item?.id} value={item?.id}>
                            {item.Task}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: 'Position',
            dataIndex: 'Position',
            // width: 130,
            render: (text, record, index) => (
                <div>
                    <Select
                        style={{ width: '120px' }}
                        mode="multiple"
                        value={record?.Position?.split(',').filter(Boolean)}  // Filter out empty strings

                        //   value={record?.Position}
                        onChange={(value) => handleSelectChange(index, value, 'Position')}
                        disabled={
                            !record?.positionOptions?.length ? true :
                                (createdByRole(index) ? false :

                                    IsNewTask(index) && roleMechanic(index) ? true :
                                        ((record?.positionOptions?.length ? false : true)
                                            || status === 'Reviewed-Approved'
                                            || status === 'Closed-WNC'
                                            || status === 'Cmpl Pending Review'
                                            || record?.Status === 'Closed'))}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {record?.positionOptions?.map((position) => (
                            <Option key={position?.value} value={position?.value}>
                                {position?.label}
                            </Option>
                        ))}
                    </Select>
                    {/* Display selected values without using an array */}

                </div>
            ),
        },

        {
            title: 'Part',
            align: "center",
            dataIndex: 'openModal',
            render: (_, record, index) => <Button
                style={{ color: '#2863ad', display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={() => handleOpenModal(index)}
                disabled={record?.Status === "Create" ? true : !record?.Status ? true : (createdByRole(index) ? false : (IsNewTask(index) && roleMechanic(index)))
                }
            > <EditOutlined style={{ marginLeft: 0 }} /></Button >

        },
        {
            title: 'Assigned To',
            dataIndex: 'AssignedToId',
            // width: 220,
            render: (text, record, index) => {
                return (
                    <div>
                        {record.assignedToType ? (
                            <Select
                                style={{ width: '120px' }}
                                disabled={
                                    (createdByRole(index) ? false :
                                        IsNewTask(index) && roleMechanic(index) ? true :
                                            (
                                                status === 'Reviewed-Approved' ||
                                                status === 'Closed-WNC' ||
                                                status === 'Cmpl Pending Review' ||
                                                record.Status === 'Closed'
                                            ))
                                }
                                value={
                                    record?.AssignedToId
                                        ? (record?.AssignedTo?.fullName || (record?.AssignedTo?.firstName + " " + record?.AssignedTo?.lastName))
                                        : record?.AssignedtoContractor
                                            ? contractormap(record?.AssignedtoContractor)
                                            : record.assignedToType == 'employee' ? '' : undefined

                                }

                                onChange={async (value, obj) => {
                                    if (value === 'back') {
                                        let temp = [...workOrderData]
                                        temp[index].assignedToType = false
                                        temp[index].AssignedToId = null
                                        setWorkOrderData(temp)
                                        handleSelectChange(index, null, 'AssignedToId');
                                        // handleSelectChange(index, 'employee', 'assignedToType');
                                    }
                                    else {
                                        let user = null /////////////////
                                        if (record?.assignedToType == 'employee')
                                            user = [...employees, ...notTerminatedEmployees]?.filter((emp) => emp?.id == obj?.key)
                                        if (record?.assignedToType == 'contractor')
                                            user = contractors?.filter((emp) => emp?.id == obj?.key)
                                        if (user?.length) {
                                            handleSelectChange(index, value, 'AssignedToId');
                                            handleSelectChange(index, user[0], 'AssignedTo');
                                            return
                                        }
                                        handleSelectChange(index, value, 'AssignedToId');
                                        handleSelectChange(index, user[0], 'AssignedTo');

                                    }
                                }}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }

                            >
                                <Option
                                    value="back"
                                    style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Back
                                </Option>
                                {record.assignedToType === 'employee'
                                    ? (record?.Category === "Electronics" ? [...employees, ...notTerminatedEmployees] : employees)?.map((item) => (
                                        <Option key={item.id} value={item.id}>
                                            {item.fullName}
                                        </Option>
                                    ))
                                    : record.assignedToType === 'contractor' && !isRoleHidden
                                        ? contractors?.map((contractor) => (
                                            <Option key={contractor.id} value={contractor.id}>
                                                {contractor.fullName}
                                            </Option>
                                        ))
                                        : null
                                }
                            </Select>
                        ) : (
                            <Select
                                style={{ width: 140, marginRight: 8 }}
                                value={record.assignedToType}
                                onChange={(value) => handleSelectChange(index, value, 'assignedToType')}
                                disabled={
                                    (!record?.Category && !record?.SubCategory && !record?.TaskId) ? true :
                                        (createdByRole(index) ? false :

                                            IsNewTask(index) && roleMechanic(index) ? true :
                                                (
                                                    status === 'Reviewed-Approved' ||
                                                    status === 'Closed-WNC' ||
                                                    status === 'Cmpl Pending Review' ||
                                                    record.Status === 'Closed'
                                                ))
                                }
                            >
                                <Option value="employee">Employee</Option>
                                {!isRoleHidden && (
                                    <Option value="contractor">Contractor</Option>
                                )}
                                {/* <Option value="contractor">Contractor</Option> */}

                            </Select>
                        )}
                    </div>
                )
            },
        },
        roleManager("LocomotiveWorkOrder", "sections", "ApproveORreject") &&
            status !== 'Scheduled' && workOrder?.complete === true && workOrder?.approve !== true
            ? {
                title: 'Status',
                dataIndex: 'approved',
                // width: 220,
                render: (text, record, index) => {
                    return <Select
                        style={{ width: '100px' }}
                        value={record.approved}
                        disabled={record?.Status === "Closed" ? true : status === 'Cmpl Pending Review' ? false : disabledCheck === true ? true :
                            (createdByRole(index) ? false :
                                IsNewTask(index) && roleMechanic(index) && roleMechanicTest2(index) ? true :
                                    ((record.Status === 'Assigned'
                                        || record.Status === 'Closed')))
                        }
                        onChange={(value) => handleSelectChange(index, value, 'approved')}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option value={true}>Accept</Option>
                        <Option value={false}>Reject</Option>
                    </Select>
                },
            }
            : {
                title: 'Status',
                dataIndex: 'Status',
                // width: 180,
                render: (text, record, index) => {
                    return <Select
                        style={{ width: '120px' }}
                        value={record?.Status}
                        disabled={
                            (!record?.AssignedToId && !record?.AssignedToContractorId)
                                ? true
                                : record?.Status
                                    ? (IsNewTask(index) && (roleMechanic(index) && roleMechanicTest2(index)))
                                        ? true
                                        : (record.Status === 'Completed'
                                            || record.Status !== 'Assigned'
                                            || status === 'Closed-WNC'
                                            || status === 'Cmpl Pending Review'
                                        )
                                    : false}
                        onChange={(value) => handleSelectChange(index, value, 'Status')}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        {statusOptions?.map((item) => (

                            <Option key={item.value} value={item.value}>
                                {item.label}
                            </Option>
                        ))}
                    </Select>
                },
            },
        {
            title: (
                <div style={{ width: '120px' }}>
                    Completed By
                </div>
            ),
            dataIndex: 'AsgnCmplById',
            style: { minWidth: 100 },
            render: (text, record, index) => {
                const completedById = record?.AsgnCmplBy?.id;
                // const employee = employees.find((emp) => emp.id === completedById);
                return (
                    <span disabled={(createdByRole(index) ? false :
                        IsNewTask(index) && roleMechanic(index) ? true :
                            (record.Status === 'Closed'))}>
                        {['Completed', 'Closed'].includes(record?.Status) ? (completedById ? `${record?.AsgnCmplBy?.firstName} ${record?.AsgnCmplBy?.lastName}` : 'N/A') : 'N/A'}
                    </span>
                );
            },
        },
        {
            title: 'Notes',
            dataIndex: 'Notes',
            // width: 220,
            render: (text, record, index) => (
                <Popover
                    content={text}
                    showArrow={false}
                    style={{ maxWidth: "200px" }}
                    className="work-order-edit-popover-antd"
                >
                    <div>
                        <Input
                            style={{ width: "120px" }}
                            placeholder='Enter Notes'
                            value={text}
                            onChange={(e) => handleFieldChange(index, e.target.value, 'Notes')}
                            disabled={
                                (createdByRole(index) ? false :
                                    IsNewTask(index) && roleMechanic(index) && roleMechanicTest2(index) ? true :
                                        (status === 'Reviewed-Approved'
                                            || status === 'Closed-WNC'
                                            || status === 'Cmpl Pending Review'
                                            || record?.Status == 'Closed')
                                )} // Disable if status is Reviewed-Approved
                        />
                    </div>
                </Popover>
            ),
        },
        {
            title: 'Action',
            // width: 100,
            dataIndex: 'action',
            align: "center",
            render: (_, record, index) => (
                <div style={{ width: '50px' }}>
                    <Button disabled={
                        (createdByRole(index) ? false :
                            (IsNewTask(index) && (roleMechanic(index) || roleMechanicTest2(index))) ? true :
                                (status === 'Reviewed-Approved'
                                    || status === 'Closed-WNC'
                                    || status === 'Cmpl Pending Review'
                                    || record?.Status == 'Closed')
                        )} // Disable if status is Reviewed-Approved
                        style={{ border: 'none', background: 'none' }} onClick={() => handleDelete(index)} ><DeleteOutlined style={{ color: '#2863ad' }} /></Button>
                </div>
            ),
        },
    ];


    useEffect(() => {
        if (workOrder) {
        }
    }, [workOrder]);

    useEffect(() => {
        fetchWorkOrders();
    }, [reload, reloadState]);
    return (
        <div className='work-order-edit'>
            <div className={mode === "view-only" ? "table-overlay-container" : ""}>
                <Table
                    columns={columns}
                    dataSource={workOrderData}
                    scroll={{
                        x: mode === "view-only" ? true : 'max-content',
                    }}
                    pagination={false}
                />
            </div>
            {(status !== 'Reviewed-Approved' && status !== 'Closed-WNC' && status !== 'Cmpl Pending Review') && (
                <Button
                    style={{
                        background: mode === "view-only" ? "lightgray" : '#2863ad',
                        color: mode === "view-only" ? "black" : 'white',
                        width: '15%',
                        borderRadius: '10px',
                        marginRight: '10px',
                        opacity: mode === "view-only" ? "0.5" : "1"
                    }}
                    onClick={addRow}
                    disabled={mode === "view-only" ? true : status === 'Reviewed-Approved' ? true : false}
                >
                    Add Task
                </Button>
            )}
            <Button
                style={{
                    borderRadius: "10px", marginLeft: "8",
                    width: "15%"
                }} onClick={handleSave}
                disabled={mode === "view-only" ? true : status === 'Reviewed-Approved' ? true : false}
            >
                Save
            </Button>
            <PartModal
                visible={partModalVisible}
                onFinish={handlePartsSave}
                onCancel={() => setPartModalVisible(false)}
                handleSelectChange={handleSelectChange}
                handleFieldChange={handleFieldChange}
                status={status}
                Form={Form}
                form={form}
            />
            <Modal
                title={
                    <div style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                        <h2 strong style={{ color: 'red' }}>
                            <NotificationFilled style={{ marginRight: '8px' }} />
                            Validation Error</h2>
                    </div>
                }
                visible={isErrorModalVisibleNotes}
                onOk={() => setIsErrorModalVisibleNotes(false)}
                footer={null}
                closable={false}

            >
                <p style={{ fontSize: '18px' }}> This task requires comments in the notes field.  Please enter comments before completing. <strong style={{ color: 'gray' }}>
                    Example: Number of gallons or type of work</strong></p>
                <div style={{ textAlign: 'center' }}>
                    <Button style={{ background: Colors?.mainBlue, color: 'white', width: '100px' }} onClick={() => setIsErrorModalVisibleNotes(false)}>
                        OK
                    </Button>
                </div>
            </Modal>
            <Modal
                title={
                    <div style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                        <h2 strong style={{ color: 'red' }}>
                            <NotificationFilled style={{ marginRight: '8px' }} />
                            Validation Error</h2>
                    </div>
                }
                visible={isErrorModalVisiblePart}
                onOk={() => setIsErrorModalVisiblePart(false)}
                footer={null}
                closable={false}
            >
                <p style={{ fontSize: '18px' }}>Please fill all required Part fields before marking the task as Completed.</p>
                <div style={{ textAlign: 'center' }}>
                    <Button style={{ background: Colors?.mainBlue, color: 'white', width: '100px' }} onClick={() => setIsErrorModalVisiblePart(false)}>
                        OK
                    </Button>
                </div>
            </Modal>
            <Modal
                title={
                    <div style={{ color: 'red', display: 'flex', alignItems: 'center' }}>
                        <h2 strong style={{ color: 'red' }}>
                            <NotificationFilled style={{ marginRight: '8px' }} />
                            Gallons Added
                        </h2>
                    </div>
                }
                open={isGallonsModalVisible}
                onOk={() => handleSubmit()}

                onCancel={() => setIsGallonsModalVisible(false)} // Handle cancel event
                footer={null}
                closable={false}
            >
                <div>
                    <p style={{ fontSize: '18px' }}>
                        <strong style={{ color: 'gray' }}>Number of gallons:</strong>
                    </p>
                    <InputNumber
                        style={{ marginBottom: '16px', width: '100%' }}
                        placeholder="Enter number of gallons"
                        min={0} // Set minimum value to 0
                        step={0.1} // Set step to allow decimal values
                        onChange={handleGallonsChange} // Handle input change
                        value={gallonsValue} // Use a state variable to store the input value
                    />
                </div>
                <div style={{ textAlign: 'center' }}>
                    <Button style={{ background: Colors?.mainBlue, color: 'white', width: '100px' }} onClick={handleSubmit}>
                        OK
                    </Button>
                </div>
            </Modal>
        </div>
    );
};

export default LocomotiveTable;